import { ErrorResponse } from "../responses/ErrorResponse";

export class ForbiddenError extends ErrorResponse {
    public message: string;
}



// WEBPACK FOOTER //
// ./src/providers/api/errors/ForbiddenError.ts